import { Option } from "./ReactSelect";

export const defaultTrimmedFilterOption = (option: Option, inputValue: string) => {
    if (!option.label || typeof option.label !== "string") {
        return false;
    }
    return option.label.toLowerCase().includes(inputValue.trim().toLowerCase());
};
